import { createAsyncThunk } from "@reduxjs/toolkit";
import { handleApiError } from "Services/Common/errorApiHandleUtils";
import { checkFilter } from "Services/Common/filterUtils";
import { orderService } from "Services/Axios/orderService";
import { toast } from "react-toastify";

export const getAllOrder = createAsyncThunk(
    'order/getAllOrder',
    async (filters, { rejectWithValue }) => {
        try {
            let filter = checkFilter(filters);
            const response = await orderService.getOrder(filter);
            return response.data;
        } catch (error) {
            return rejectWithValue(handleApiError(error));
        }
    }
);

export const exportOrders = createAsyncThunk(
    'order/exportOrders',
    async (filters, { rejectWithValue }) => {
        try {
            const filter = checkFilter(filters);
            const response = await orderService.exportOrder(filter);

            // Blob handling
            const url = URL.createObjectURL(new Blob([response.data]));
            const link = document.createElement('a');
            link.href = url;
            link.setAttribute('download', 'export-reservasi-qeza-app.xlsx');
            document.body.appendChild(link);
            link.click();
            link.remove();
        } catch (error) {
            return rejectWithValue(handleApiError(error));
        }
    }
);


export const addTreatment = createAsyncThunk(
    'order/addTreatment',
    async ({ id, data }, { dispatch, rejectWithValue, getState }) => {
        try {
            const formData = new FormData();
            if (data.treatment_ids && data.treatment_ids.length > 0) {
                data.treatment_ids.forEach((item) => {
                    formData.append('treatment_ids[]', item);
                });
            }
            const response = await orderService.addTreatment(id, formData);
            const filters = getState().order.filters;
            dispatch(getAllOrder(filters));
            return response.data;
        } catch (error) {
            if (error.response.status === 422) {
                toast.error("reservasi online tidak bisa menambah perawatan");
            }
            return rejectWithValue(handleApiError(error));
        }
    }
);

export const addNote = createAsyncThunk(
    'order/addNote',
    async ({ id, data }, { dispatch, rejectWithValue, getState }) => {
        try {
            const formData = new FormData();
            formData.append('cs_notes', data.cs_notes);
            const response = await orderService.addNote(id, formData);
            const filters = getState().order.filters;
            dispatch(getAllOrder(filters));
            return response.data;
        } catch (error) {
            return rejectWithValue(handleApiError(error));
        }
    }
);

export const addOrder = createAsyncThunk(
    'order/addOrder',
    async (data, { dispatch, rejectWithValue, getState }) => {
        try {
            const formData = new FormData();
            formData.append('user_id', data.user_id);
            formData.append('branch_id', data.branch_id);
            formData.append('schedule_hour_start', data.schedule_hour_start);
            formData.append('schedule_hour_end', data.schedule_hour_end);
            formData.append('schedule_date', data.schedule_date);
            formData.append('cs_notes', data.cs_notes);
            
            const response = await orderService.addOrder(formData);
            data.successCallback && data.successCallback();
            const filters = getState().order.filters;
            dispatch(getAllOrder(filters));
            return response.data;
        } catch (error) {
            return rejectWithValue(handleApiError(error));
        }
    }
);

export const changeStatus = createAsyncThunk(
    'order/changeStatus',
    async ({ id, data }, { dispatch, rejectWithValue, getState }) => {
        try {
            const formData = new FormData();
            formData.append('status', data.status);
            const response = await orderService.changeStatus(id, formData);
            const filters = getState().order.filters;
            dispatch(getAllOrder(filters));
            return response.data;
        } catch (error) {
            return rejectWithValue(handleApiError(error));
        }
    }
);

export const reschedule = createAsyncThunk(
    'order/reschedule',
    async ({ id, data }, { dispatch, rejectWithValue, getState }) => {
        try {
            const formData = new FormData();
            formData.append('schedule_date', data.schedule_date);
            formData.append('schedule_hour_start', data.schedule_hour_start);
            formData.append('schedule_hour_end', data.schedule_hour_end);
            const response = await orderService.reschedule(id, formData);
            const filters = getState().order.filters;
            dispatch(getAllOrder(filters));
            return response.data;
        } catch (error) {
            return rejectWithValue(handleApiError(error));
        }
    }
);